import { FaPlus } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import tw from "tailwind-styled-components";
import { truncateText } from "../helpers";

const CategoryCard = ({ selectedCategory, onClick, title, disabled = false }) => {
    const hasSelection = !!selectedCategory;

    const label = selectedCategory
        ? selectedCategory.label ||
        selectedCategory.name ||
        selectedCategory.roomNum ||
        selectedCategory.bankName
        : null;

    return (
        <CardContainer
            $hasSelection={hasSelection}
            $disabled={disabled}
            onClick={disabled ? undefined : onClick}
            // onClick={onClick}
            type="button"
            disabled={disabled}
        >
            <CardContent>
                {/* LEFT CONTENT */}
                <div className="flex flex-col text-left min-w-0">
                    <Title>
                        {title}
                    </Title>

                    <CategoryName $hasSelection={hasSelection}>
                        {hasSelection
                            ? truncateText(label, 28)
                            : "Select to continue"}
                    </CategoryName>
                </div>

                {/* RIGHT ACTION */}
                {!disabled && (
                    <ActionWrapper $hasSelection={hasSelection}>
                        {hasSelection ? (
                            <>
                                <MdEdit className="w-3 h-3" />
                                <span>Edit</span>
                            </>
                        ) : (
                            <>
                                <FaPlus className="w-3 h-3" />
                                <span>Add</span>
                            </>
                        )}
                    </ActionWrapper>
                )}

            </CardContent>
        </CardContainer>
    );
};

// Styled Components
// const CardContainer = tw.button`w-full group relative overflow-hidden rounded-md px-2 py-2 transition-all duration-300 ease-out border border-gray-200 bg-white h-12`;
// const CardContent = tw.div`flex justify-between items-center gap-3`;
// const CategoryName = tw.div`text-sm transition-colors truncate text-gray-600 pl-2`;
// const GroupBadge = tw.span`inline-flex items-center px-2 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-medium mt-1`;
const IconWrapper = tw.div`ml-2 flex-shrink-0 p-2 rounded-lg transition-all duration-300 bg-gray-100 text-gray-600`;

// const CardContainer = tw.button`
//   w-full group flex items-center
//   rounded-md px-4 py-3
//   border border-gray-200 bg-white
//   transition-all duration-200
//   hover:border-primary-color hover:shadow-sm
//   active:scale-[0.99]
// `;
const CardContainer = tw.button`
  w-full group flex items-center
  rounded-md px-4 py-3
  border bg-white
  transition-all duration-200
  ${(p) =>
        p.$disabled
            ? "border-gray-200 cursor-not-allowed opacity-60"
            : "border-gray-200 hover:border-primary-color hover:shadow-sm active:scale-[0.99]"
    }
`;
const CardContent = tw.div`
  flex justify-between items-center w-full gap-4
`;

const Title = tw.p`
  text-xs text-gray-400 mb-0.5
`;

const CategoryName = tw.p`
  text-sm font-medium truncate
  ${(p) => (p.$hasSelection ? "text-gray-800" : "text-gray-400")}
`;

const ActionWrapper = tw.div`
  flex items-center gap-1.5
  text-xs font-medium px-2.5 py-1.5
  rounded-lg transition-all
  bg-gray-100 text-gray-700 group-hover:bg-gray-200
  
`;
// ${(p) =>
//         p.$hasSelection
//             ? "bg-gray-100 text-gray-700 group-hover:bg-gray-200"
//             : "bg-primary-color text-white group-hover:opacity-90"}
export default CategoryCard;